export const POSITION_TYPES = [
  'positionTypes.casual',
  'positionTypes.contract',
  'positionTypes.intern',
];
